import React from "react"
import { Nav } from "react-bootstrap"
import { Link } from "gatsby"

export const StyledLink = ({ children, ...props }) => (
  <Nav.Link
    as={Link}
    activeStyle={{
      textDecoration: "none",
      color: "#1f7abf",
    }}
    {...props}
  >
    {children}
  </Nav.Link>
)
